import { httpEConfig, httpGreylock } from './http.commonEConfigPlus';

class EConfigratorService {
  //Econfig plus api method
  getAll(apiName) {
    return httpEConfig.get(apiName);
  }
  getById(apiName, id) {
    return httpEConfig.get(`${apiName}/${id}`);
  }
  postById(apiName, id) {
    return httpEConfig.post(`${apiName}/${id}`);
  }
  postByObject(apiName, postData) {
    return httpEConfig.post(apiName, postData);
  }
  update(apiName, id, data) {
    return httpEConfig.put(`${apiName}/${id}`, data);
  }

  deleteByID(apiName, id) {
    return httpEConfig.delete(`${apiName}/${id}`);
  }
  delete(apiName) {
    return httpEConfig.delete(`${apiName}`);
  }

  // Greylock api method
  get(apiName) {
    return httpGreylock.get(apiName);
  }
}
export default new EConfigratorService();
